import React from 'react'
import './FaceBook.css'
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
const FaceBook = () => {
  return (
    <div>
         <div class="linkedin">
    <a href="https://www.linkedin.com/in/royalhood-in-0b1561346?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank">
        <FaLinkedinIn style={{color:"white",fontSize:"30px"}}/><span></span><span>LinkedIn<br/><small></small></span>
    </a>
</div>
    </div>
  )
}

export default FaceBook
